export const capitalize = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
/**
 * Appends a new note to existing notes with the current date.
 * @param existingNotes The existing note
 * @param newNote The new note to append.
 * @returns A new string with the new note appended, prefixed by the current date.
 */
export const appendToNote = (existingNotes, newNote, author = 'system') => {
    if (newNote?.trim().length > 0) {
        const date = new Date().toISOString().split('T')[0];
        const formattedNote = `${date} (${author}): ${newNote}`;
        return existingNotes ? `${existingNotes}\n${formattedNote}` : formattedNote;
    }
    else {
        return newNote;
    }
};
//# sourceMappingURL=stringFormatting.js.map